module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-800-heavy-italic-2588120a025bf760fef945579e70b891.woff2";